// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Title_loaderWrapper__vs6VM"};